/*eslint-disable*/
import _ from 'lodash'
import UserApi from '../../api/user/user'

export default [
    {
        path: 'user/:type',
        name: 'user:list',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "user" */'../../components/lists/List.vue'),
        meta: {
            title(route) {
                switch (route.params.type) {
                    case 'student':
                        return 'router.router_students';
                    case 'teacher':
                        return 'router.router_teachers';
                    case 'admin':
                        return 'router.router_admins';
                    default:
                        return 'router.router_list';
                }
            },
            prev: {
                name: 'dashboard'
            }
        },
        props($route) {
            return {
                type: $route.params.type,
                page: $route.query.page
            }
        }
    },
    {
        path: 'user/:type/:id',
        name: 'user:profile',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "user" */'../../components/profiles/User.vue'),
        meta: {
            title: _.throttle((route) => {
                return UserApi.show(route.params.id).then((user) => {
                    return user.fullName;
                });
            }, 100, {trailing: false}),
            prev: {
                name: 'user:list'
            }
        },
        props: true
    },
    {
        path: 'user/:type/create',
        name: 'user:create',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "user" */'../../components/user/Create.vue'),
        meta: {
            title(route) {
                switch (route.params.type) {
                    case 'student':
                        return 'router.router_addStudent';
                    case 'teacher':
                        return 'router.router_addTeacher';
                    case 'admin':
                        return 'router.router_addAdmin';
                    default:
                        return 'router.router_add';
                }
            },
            prev: {
                name: 'user:list'
            },
        },
        props: true
    },
    {
        path: 'user/:type/:id/edit',
        name: 'user:edit',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "user" */'../../components/user/Edit.vue'),
        meta: {
            title: 'router.router_editProfile',
            prev: {
                name: 'user:profile'
            },
        },
        props: true
    },
    {
        path: 'user-playtime-ended',
        name: 'user:playtime-ended',
        component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "sidebar" */'../../components/user/PlaytimeEnded.vue'),
        meta: {
            title: 'router.router_playtime_ended',
            prev: {
                name: 'dashboard'
            }
        },
    },
]
